import React from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FormattedMessage } from "react-intl";
import useCustomRouting from "../../../hooks/useCustomRouting";
const BackButton = () => {
  const { redirectToPath } = useCustomRouting();
  return (
    <>
      <h4
        className="d-flex justify-content-start align-items-center fs-6 custom-theme-color back-button-details"
        role="button"
        onClick={() => {
          redirectToPath("/identity-management");
        }}
      >
        <FaArrowLeftLong className="px-2" size={40} />
        <span className="text-uppercase ps-2">
          <FormattedMessage
            id="id.details.return-to-id"
            defaultMessage="Return To Identity Management"
          />
        </span>
      </h4>
    </>
  );
};

export default BackButton;
